{
  "api_keys": {
    "title": "Caabi API yi",
    "create_title": "Caabi API bu bees",
    "create_button": "Sos caabi",
    "name_label": "Tur",
    "name_placeholder": "Misaal : Appli portable",
    "prefix_label": "Njëkk",
    "permissions_label": "Sañ-sañ yi",
    "last_used": "Jëfandikoo bu mujj",
    "status": "Yoonu",
    "never_used": "Jëfandikoo wuñu ko",
    "new_key_warning": "Def copy caabi bi léegi. Dunu ko won kenn.",
    "revoke_button": "Neenal",
    "revoke_confirm": "Dëgg nga bëgg ko neenal?",
    "empty": "Amul caabi API",
    "empty_description": "Sos caabi API ngir jokkoo ak sa systeem yi ci biti"
  },
  "permissions": {
    "orders:read": "Jàng komand yi",
    "orders:write": "Soppi komand yi",
    "products:read": "Jàng produwe yi",
    "customers:read": "Jàng kiliyaan yi",
    "inventory:read": "Jàng stock bi",
    "webhooks:manage": "Saytu webhooks yi"
  },
  "webhooks": {
    "title": "Webhooks yi",
    "create_title": "Webhook bu bees",
    "create_button": "Yokk webhook",
    "url_label": "URL bu jëmë",
    "events_label": "Xew-xew yi",
    "secret_auto": "Benn secret dinu ko sos ngir signer requêtes yi.",
    "test_button": "Jéema",
    "show_deliveries": "Won yonnee yi",
    "hide_deliveries": "Nëbb yonnee yi",
    "delete_button": "Far",
    "delete_confirm": "Dëgg nga bëgg ko far?",
    "failures": "{{count}} njuumte",
    "last_status": "Yoonu bu mujj",
    "empty": "Amul webhook",
    "empty_description": "Yokk webhook ngir jot xibaar yi ci waxtu wi"
  },
  "events": {
    "order.created": "Komand bu sos",
    "order.paid": "Komand bu fey",
    "order.shipped": "Komand bu yonnee",
    "order.delivered": "Komand bu agsi",
    "order.cancelled": "Komand bu neenal",
    "payment.confirmed": "Fey bu dëgg",
    "payment.failed": "Fey bu jotul",
    "stock.low": "Stock bu waññi",
    "customer.created": "Kiliyaan bu bees"
  },
  "delivery": {
    "title": "Liggéeyu yonnee yi",
    "timestamp": "Bés ak waxtu",
    "event": "Xew-xew",
    "status_code": "Code HTTP",
    "response_time": "Waxtu tontu",
    "result": "Ayu",
    "success": "Baax na",
    "failed": "Jotul",
    "empty": "Amul yonnee bu denc"
  },
  "status": {
    "active": "Aktif",
    "revoked": "Neenal na",
    "inactive": "Taxawul"
  },
  "actions": {
    "cancel": "Neenal",
    "confirm": "Dëggal",
    "copy": "Def copy",
    "copied": "Copy na!",
    "dismiss": "Tëj"
  }
}
